/**
 * TRIP-3656: Webkit messageHandlers shim for Facebook iOS in-app browser.
 *
 * iPhone users arriving via Facebook paid ads open the booking widget inside the
 * Facebook iOS in-app browser (FBIAN). The Facebook iOS SDK injects LCP performance
 * monitoring code synchronously — before TripWorks' webpack bundle finishes loading.
 * That code calls window.webkit.messageHandlers.<handler>.postMessage(...) which
 * crashes when messageHandlers is undefined.
 *
 * This module exports the shim installer so it can be:
 *   1. Called from trip-builder-iframe.js after bundle load
 *   2. Tested directly in unit tests (no mirror duplication needed)
 *
 * The twig inline <script> in trip_builder.html.twig installs the shim first
 * (before any bundle tags). The __webkitShimInstalled sentinel prevents double-wrapping.
 */

/**
 * Install a Proxy shim on window.webkit.messageHandlers that returns a no-op
 * postMessage stub for any undefined handler, preventing crashes from third-party
 * code (e.g. Facebook iOS SDK) that calls handlers before native bridges are set up.
 *
 * @param {Window} win - The window object to install on (injectable for testing)
 */
export function installWebkitShim(win = window) {
  if (!win.webkit) win.webkit = {};
  if (!win.webkit.messageHandlers) win.webkit.messageHandlers = {};
  try {
    if (win.__webkitShimInstalled) return;
    win.webkit.messageHandlers = new Proxy(win.webkit.messageHandlers, {
      get(target, property) {
        if (target[property]) return target[property];
        return {
          postMessage() {
            return Promise.resolve(null);
          },
        };
      },
    });
    win.__webkitShimInstalled = true;
  } catch (_e) {
    // In strict mode, assigning to a non-writable property throws TypeError (caught here).
    // In sloppy mode it silently fails — the guarantee is no crash, not that the Proxy installed.
  }
}
